import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function login(data) {
    return request.post(`/${platform}/auth/login`, data)
}

export function getFails(data) {
    return request.get(`/${platform}/auth/fails`, data)
}

// 【已停用】钉钉登录入口
// export function dingtalkLogin(data) {
//     return request.post(`/${platform}/auth/dingtalk_login`, data)
// }



